import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ReservationCustomer, ReservationDraft } from '@/types';

const initialState: ReservationDraft = {
  partySize: null,
  date: null,
  time: null,
  customer: { name: '', phone: '', email: '' },
  note: '',
};

const reservationSlice = createSlice({
  name: 'reservation',
  initialState,
  reducers: {
    setPartySize(state, a: PayloadAction<number>) {
      state.partySize = a.payload;
    },
    setDate(state, a: PayloadAction<string>) {
      state.date = a.payload;
      state.time = null;
    },
    setTime(state, a: PayloadAction<string | null>) {
      state.time = a.payload;
    },
    setCustomer(state, a: PayloadAction<Partial<ReservationCustomer>>) {
      Object.assign(state.customer, a.payload);
    },
    setNote(state, a: PayloadAction<string>) {
      state.note = a.payload;
    },
    resetReservation() {
      return initialState;
    },
  },
});

export const {
  setPartySize,
  setDate,
  setTime,
  setCustomer,
  setNote,
  resetReservation,
} = reservationSlice.actions;

export default reservationSlice.reducer;

export const selectReservation = (state: { reservation: ReservationDraft }) =>
  state.reservation;
